import React, { Component } from "react";
import "./FirstPageStyle.css";
import BOTTOM_BLOB from "../media/bottom_blob.svg";
import TOP_BLOB from "../media/top_blob.svg";
import DOWN_ARROW from "../media/down_arrow.svg";
import LinkedIn from "../media/linked.png";

import { ToastContainer, toast } from 'react-toastify';
import FirstPagePreviews from "./FirstPagePreviews";

class FirstPage extends Component{

    constructor(props){
        super(props);
    }

    scrollToAboutMe(){
        var element = document.getElementById("about");
        window.scrollTo({
            top:element.offsetTop,
            behavior:"smooth"
        });
    }

    scrollToProjects(instant = false){
        var element = document.getElementById("projects");
        if (instant){
            window.scrollTo({
                top:element.offsetTop,
                behavior: "auto"
            });
        }else{
            window.scrollTo({
                top:element.offsetTop,
                behavior:"smooth"
            });
        }
    }

    setContactVisibility(){
        var element = document.getElementById("contact");
        var element2 = document.getElementById("fade");
        element.style.display = "block";
        element2.style.display = "block";
    }

    removeContactVisibility(){
        var element = document.getElementById("contact");
        var element2 = document.getElementById("fade");
        element.style.display = "none";
        element2.style.display = "none";
    }

    componentDidMount(){
        if (this.props.gotoProjects){
            this.scrollToProjects(true);
        }
    }

    render(){
        const notify = () => toast("email copied to clipboard");
        return <div id="top" className="first-page">
            <FirstPagePreviews />
            <div className="container">
                <span className="header"><h1 className="header-name">Alexander Lamarche
                </h1><span className="header-position">Software Engineer | Game Developer | Interactive Media</span>
                </span>
                <div className="nav">
                    <ul>
                        <li onClick={this.scrollToAboutMe}>About</li>
                        <li onClick={()=>{this.scrollToProjects(false)}}>Projects</li>
                        <li onClick={()=>{
                            notify();
                            navigator.clipboard.writeText("alexlamarche90@gmail.com");
                        }}>Contact</li>
                        <li className="nav-linkedin" onClick={()=>{
                            window.open("https://www.linkedin.com/in/alex-lamarche/", "_blank");
                        }}><img className="linked-img" src={LinkedIn} alt="LinkedIn"/></li>
                    </ul>
                </div>
            </div>
            <div onClick={this.scrollToAboutMe} className="arrow-down"><img className="bottom-arrow" src={DOWN_ARROW}></img></div>
            {/* <img className="bottom-blob" src={BOTTOM_BLOB}></img> */}
            {/* <img className="top-blob" src={TOP_BLOB} /> */}
            <div id="fade" className="background-fade"></div>
            <div id="contact" className="contact-modal">
                <p className="email">alexlamarche90@gmail.com</p>
                <a href="https://www.linkedin.com/in/alex-lamarche/" target="_blank">www.linkedin.com/in/alex-lamarche/</a>
                <div className="contact-close" onClick={this.removeContactVisibility}>close</div>
            </div>
            <div className="toast">            <ToastContainer
                position="bottom-right"
                autoClose={5000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick={false}
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="dark"
            /></div>

        </div>;
    }
}

export default FirstPage;